// @ts-nocheck
import React from "react";

export default function ViewToggle({ view, onChange, mapEnabled }) {
  return (
    <div className="view-toggle" role="tablist" aria-label="Event view toggle">
      <button
        type="button"
        role="tab"
        aria-selected={view === "map"}
        className={`toggle-btn ${view === "map" ? "active" : ""}`}
        onClick={() => onChange("map")}
        disabled={!mapEnabled}
      >
        Map View
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={view === "list"}
        className={`toggle-btn ${view === "list" ? "active" : ""}`}
        onClick={() => onChange("list")}
      >
        List View
      </button>
      {!mapEnabled && (
        <span className="toggle-note">Map unavailable, showing list</span>
      )}
    </div>
  );
}
